import {userConstants as constants} from '../constants';
import {authHeader, config, responseHandler} from '../helpers';
import AuthService from '../services/auth.service';

export const userActions = {
    linkEmailToAccount,
    getConnectionsForDomain
};

function linkEmailToAccount(email) {
    return async dispatch => {
        dispatch(request(email));

        const url = config.authUrl + `/LinkEmailToAccount?email=${email}`;
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };

        await fetch(url, requestOptions)
            .then(
                async response => {
                    
                    let responseObject = await responseHandler.handleResponse(response);
                    let emailWasTaken = responseObject.emailWasTaken;
                    let connectionNames = responseObject.connectionNames;
                    
                    if(connectionNames) {
                        // Skicka till extern SSO
                        dispatch(otherLoginConnectionExists(connectionNames));
                    }
                    else if(emailWasTaken)
                    {
                        dispatch(userExists());
                        // Skriv ut att användare redan finns med denna epost. Kontakta support@legly.io
                    }
                    else {
                        dispatch(accountLinkSuccess());
                        new AuthService().reauthenticateAfterAccountLink();
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(email) {
        return {type: constants.LINK_EMAIL_REQUEST};
    }

    function otherLoginConnectionExists(connectionNames) {
        return {type: constants.LINK_EMAIL_OTHER_LOGIN_CONNECTION_EXISTS, connectionNames};
    }
    
    function userExists(email) {
        return {type: constants.LINK_EMAIL_USER_EXISTS};
    }
    
    function accountLinkSuccess(email) {
        return {type: constants.LINK_EMAIL_SUCCESS};
    }

    function failure(error) {
        return {type: constants.LINK_EMAIL_FAILURE, error};
    }
}

function getConnectionsForDomain(email) {
    return async dispatch => {
        dispatch(request(email));

        const url = config.authUrl + `/GetAuth0ConnectionNamesForUser?email=${email}`;
        const requestOptions = {
            method: 'GET'
        };

        await fetch(url, requestOptions)
            .then(
                async response => {

                    var connectionNames = (await responseHandler.handleResponse(response)).connectionNames;

                    // 1. Om en och endast en connection -> skicka redirect till auth0 med den connection
                    // 2. Om det är en lista med connections -> lista alla olika connections och låt användaren välja
                    // 3. Om ingen connection hittas så skicka ett meddelande om den inte hittades

                    dispatch(success(connectionNames));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(email) {
        return {type: constants.GET_CONNECTION_NAMES_REQUEST};
    }

    function success(connectionNames) {
        return {type: constants.GET_CONNECTION_NAMES_SUCCESS, connectionNames};
    }

    function failure(error) {
        return {type: constants.GET_CONNECTION_NAMES_FAILURE, error};
    }
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js